import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 md:py-24 px-5 md:px-8 bg-dark-300 border-t border-dark-100 relative overflow-hidden" data-id="element-11">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[400px] md:w-[800px] h-[200px] md:h-[400px] bg-gold/5 rounded-full blur-[80px] md:blur-[100px] pointer-events-none translate-y-1/2" data-id="element-12" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gold mb-8 md:mb-10 tracking-tight leading-tight" data-id="element-15">
            Deja de perseguir leads fríos. Empieza a cerrar transacciones.
          </h2>

          <div className="w-full sm:w-auto flex justify-center" data-id="element-16">
            <Button href="https://calendar.app.google/PYPdcRoYne7QrNJA7" className="w-full sm:w-auto px-6 py-4 md:px-10 md:py-5 text-sm md:text-lg" data-id="element-17">
              QUIERO TRANSACCIONES CALIFICADAS ESTE MES
            </Button>
          </div>

          <p className="mt-6 text-gray-500 text-xs md:text-sm font-medium" data-id="element-18">
            Agenda tu sesión estratégica gratuita. Cupos limitados por zona.
          </p>
        </motion.div>
      </div>
    </section>;
}